import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { translations } from "@/i18n/translations";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Species } from "@/components/Species";
import { Gallery } from "@/components/Gallery";
import { Contact } from "@/components/Contact";

function App() {
  const [lang, setLang] = useState("pt");
  const t = translations[lang];

  useEffect(() => {
    const lenis = new Lenis({ anchors: true, lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-ink text-bone">
      <div className="noise-overlay" aria-hidden="true" />
      <Header t={t} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t} />
        <Marquee items={t.marquee} />
        <About t={t} />
        <Species t={t} />
        <Gallery t={t} />
        <Contact t={t} />
      </main>
    </div>
  );
}

export default App;
